import { z } from 'zod';

export const authSessionSchema = z.object({
  userId: z.union([z.string(), z.number()]).transform(String),
  email: z.string().optional().nullable(),
  name: z.string().optional().nullable(),
  status: z.string().optional().nullable(),
  role: z.string().optional().nullable(),
  avatarUrl: z.string().optional().nullable(),
}).passthrough();

export function parseAuthSession(raw) {
  if (raw == null) return null;
  const result = authSessionSchema.safeParse(raw);
  if (!result.success) {
    console.warn('[zod] auth session soft-fail', result.error.flatten());
    return raw;
  }
  return result.data;
}
